import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 40,
			height: 40,
			rx: 20,
			fill: "#FEF2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 31C14.4771 31 10 26.5228 10 21C10 15.4771 14.4771 11 20 11C25.5228 11 30 15.4771 30 21C30 26.5228 25.5228 31 20 31ZM20 29C24.4183 29 28 25.4183 28 21C28 16.5817 24.4183 13 20 13C15.5817 13 12 16.5817 12 21C12 25.4183 15.5817 29 20 29ZM21 21H25V23H19V16H21V21Z",
			fill: "#DC2626"
		})
	]
});
const ForwardRef = forwardRef(SvgDuration);
export { ForwardRef as ReactComponent };
